import Cookies from 'js-cookie';

export default () => {

    const alert = document.querySelector('[data-alert]');
    const alertClose = document.querySelector('[data-alert-close]');
    const date = new Date();
    if (alert) {
        const val = Cookies.get(alert.getAttribute('data-alert'));
        if (!val || dateDiff(date, new Date(val)) >= 2) {
            alert.classList.add('active');
        }

        alertClose.addEventListener('click', (e) => {
            e.preventDefault();
            Cookies.set(alert.getAttribute('data-alert'), date.toDateString());
            alert.classList.remove('active');
            return false;
        })
    }

    function dateDiff(date1, date2)
    {
        return Math.ceil((date1.getTime() - date2.getTime()) / (24 * 60 * 60 * 1000))
    }

}
